import React from 'react';
import moment from 'moment';

import { MCButton } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { permissions } from 'src/helpers';

import TreatmentItem from './item';
import LANG_CONST from '../../helpers/lang/const';
import MCVirtuoso from 'components/complex/MCVirtuoso';
import { remCss } from 'src/helpers';

const { ACTIONS } = permissions;

class Treatment extends BaseComponent {
  virtuoso = null;
  componentDidMount() {
    this.props.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  render() {
    let { model, onlyMine, onPrivacySettings, showDoctor, onSeeMore } = this.props;
    let user = model.getUser();

    return (
      <>
        {!onlyMine && ACTIONS.TREATMENTS_ADD_BUTTON.isActive && (
          <div className={'mc-flex mc-wrap  mc-mlr30 mc-mt20'}>
            <div className={'mc-grow'} />
            <div className={'mc-flex mc-wrap'} style={{ marginLeft: remCss(5) }}>
              <MCButton
                medium
                light
                primary
                radius
                type={'link'}
                to={permissions.PAGES.CREATE_TREATMENTS_PAGE.match(model.state.partnerId)}
                // onClick={() =>
                //   popupModel.setActivePopup(ACTIONS.TREATMENTS_ADD_BUTTON.key, {
                //     active: true,
                //     component: AddTreatment,
                //     props: { model }
                //   })
                // }
                label={LANG_CONST.buttons.add_treatment}
              />
            </div>
          </div>
        )}
        <div className={'mc-treatment mc-mt20'}>
          <MCVirtuoso
            model={model}
            ref={(ref) => (this.virtuoso = ref)}
            itemContent={(index, item) => {
              let timeMessage = moment(item.date).format('ddd,DD MMM');
              if (index === 0) {
                this.lastDate = timeMessage;
              } else if (this.lastDate === timeMessage) {
                timeMessage = null;
              } else {
                this.lastDate = timeMessage;
              }
              return (
                <TreatmentItem
                  key={index}
                  {...item}
                  timeMessage={timeMessage}
                  item={item}
                  index={index}
                  auth={user}
                  router={this.props.router}
                  onPrivacySettings={onPrivacySettings}
                  showDoctor={showDoctor}
                  openId={model.state.openId}
                  privacySettingsData={item.data?.privacySettings}
                  onOpenId={(item) => {
                    model.setState({ openId: model.state.openId === item.id ? null : item.id });
                    setTimeout(() => {
                      if (this.virtuoso)
                        this.virtuoso.scrollToIndex({ index: index, behavior: 'smooth' });
                    }, 250);
                  }}
                  onSeeMore={onSeeMore}
                />
              );
            }}
          />
        </div>
      </>
    );
  }
}

export default Treatment;
